const ONBOARDING_STATE_KEY = (applicationId) => `onboardingState_${applicationId}`;

const OnboardingSessionStorage = {
  setOnboardingState(applicationId, state) {
    sessionStorage.setItem(ONBOARDING_STATE_KEY(applicationId), state);
  },

  getOnboardingState(applicationId) {
    return sessionStorage.getItem(ONBOARDING_STATE_KEY(applicationId)) || null;
  },
};

export const setOnboardingState = OnboardingSessionStorage.setOnboardingState;
export const getOnboardingState = OnboardingSessionStorage.getOnboardingState;
